import { forwardRef, memo } from 'react'

import { useUploadInputFileModel } from './upload-input-file.model'
import type { IUploadInputFileProps } from './upload-input-file.types'
import { UploadInputFileView } from './upload-input-file.view'

const Component = forwardRef<HTMLInputElement, IUploadInputFileProps>(
  ({ id, children, onUpload, onError, config }, ref) => {
    const { handleChange, acceptAttribute, isMultiple } = useUploadInputFileModel(onUpload, onError, config)

    return (
      <UploadInputFileView
        id={id}
        onChangeInput={handleChange}
        acceptAttribute={acceptAttribute}
        isMultiple={isMultiple}
        inputRef={ref}
      >
        {children}
      </UploadInputFileView>
    )
  }
)

Component.displayName = 'UploadInputFile'
export const UploadInputFile = memo(Component)
